import { render, staticRenderFns } from "./waybillDetail.vue?vue&type=template&id=345e3f5f&"
import script from "./waybillDetail.vue?vue&type=script&lang=js&"
export * from "./waybillDetail.vue?vue&type=script&lang=js&"
import style0 from "./waybillDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "waybillDetail.vue"
export default component.exports